var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.6765 2.37745L2.32353 24.2696","stroke":"#7E93B4","strokeWidth":"3","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M2.32357 2.37744L23.6765 24.2696","stroke":"#7E93B4","strokeWidth":"3","strokeLinecap":"square","key":1})]);
}

CloseInline.defaultProps = {"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
